import React from "react";
import cn from "classnames";
import styles from "./form.module.sass";
import Icon from "../Icon";

const Form = ({className, onChange, as, onSubmit, placeholder, value, type, name, icon, size}) => {
  
  return (
    <form className={cn(className, styles.form, {[styles.sm] : (size === 'sm')})} onSubmit={onSubmit}>
      <input className={(as && as == 'players') ? styles.inputWhite : cn(styles.input, {[styles.sm] : (size === 'sm')})} type={type} onChange={onChange} name={name} value={value} placeholder={placeholder} required />
      <button className={styles.result}>
        <Icon name={icon} size="16" />
      </button>
    </form>
  );
};

export default Form;
